__turbopack_context__.v({
  "image_area": "-AOc1W_image_area",
  "image_block": "-AOc1W_image_block",
  "referFriendBg": "-AOc1W_referFriendBg",
  "richtext": "-AOc1W_richtext",
});
